function upcoming_Reducer(state = [], action) {
    switch (action.type) {
        case 'UPCOMING/SET':
            return action.upcoming;
        case 'UPCOMING/CLEAR':
            return null;
        default:
            return state;
    }
}

export default upcoming_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/upcoming.js